import React, { FC } from 'react'
import { StyledIframe } from './styled'

export interface IframeProps {
	url: string
	title?: string
	allowFullScreen?: boolean
	minHeight?: number
	indent?: number
	className?: string
}

export const IframeComponent: FC<IframeProps> = ({
	url,
	title = 'Фрейм',
	allowFullScreen,
	minHeight,
	indent = 200,
	className,
}) => {
	return (
		<StyledIframe
			className={className}
			minHeight={minHeight}
			indent={indent}
			title={title}
			src={url}
			allowFullScreen={allowFullScreen}
		/>
	)
}
